import axios from 'axios'
import type {
  CoverageByCriteriaRequest,
  CoverageByCriteriaResponse,
  CoverageDetailResponse,
  CoverageFilters,
  CoverageListRequest,
  CoverageListResponse,
  CoverageStatusCountsResponse,
} from 'types'

export const coverageList = (request: CoverageListRequest) =>
  axios
    .get<CoverageListResponse>('/api/coverages', { params: request })
    .then((res) => res.data)

export const coverageCount = (filters?: CoverageFilters) =>
  axios
    .get<CoverageStatusCountsResponse>('/api/coverages/count', {
      params: { filters },
    })
    .then((res) => res.data)

export const coverageGet = (coverageUuid: string) =>
  axios
    .get<CoverageDetailResponse>(`/api/coverages/${coverageUuid}`)
    .then((res) => res.data)

export const COVERAGE_EXPORT_ENDPOINT = '/api/coverages/export'

export const coverageGetByCriteria = (request: CoverageByCriteriaRequest) =>
  axios
    .get<CoverageByCriteriaResponse>(`/api/coverages/by-criteria`, {
      params: request,
    })
    .then((res) => res.data)
